import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./Thankyou.css"; // Import custom CSS

function Thankyou() {
  return (
    <div className="thankyou-container">
      <Helmet>
        <title>Thank You | Web Inventix</title>
        <meta
          name="description"
          content="Thank you for reaching out to Web Inventix. One of our account directors will contact you shortly."
        />
        <meta name="robots" content="noindex, nofollow" />
         <script>
          {`gtag('event', 'conversion', {'send_to': 'AW-17053349104/MeWkCPqdld0aEPDp1cM_'});`}
        </script>
      </Helmet>
      <div className="thankyou-page">
        <div className="thank-you-container">
          <img
            src="/professional-website-development/assets/images/thank.png"
            alt="Ebook Illustration"
            className="illustration"
          />
          <h1>Thank You!</h1>
          <p>Your request has been received successfully.</p>
          <Link to="/" className="thank-you-button">
            Go Back to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Thankyou;
